import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import dayjs from "dayjs";
import { RootState } from "..";
import { envConfig } from "../../constants/config";
import { LeaderboardsData } from "../../constants/types";

// import { history, fetchWrapper } from '_helpers';

interface leaderboardsState {
  leaderboards: Array<LeaderboardsData>;
  userMetaInfo: object | null;
  slug: string;
  error: boolean;
  loading: boolean;
}

// create slice

const name = "leaderboards";
const initialState: leaderboardsState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const leaderboardsActions = { ...slice.actions, ...extraActions };
export const leaderboardsReducer = slice.reducer;

// implementation

function createInitialState(): leaderboardsState {
  return {
    leaderboards: [],
    userMetaInfo: null,
    slug: "",
    // initialize state from local storage to enable user to stay logged in
    error: false,
    loading: false,
  };
}

function createReducers() {
  return {
    logout,
  };

  function logout(state: leaderboardsState) {
    state.leaderboards = [];
    localStorage.removeItem("token");
    // history.navigate('/login');
  }
}

function createExtraActions() {
  return {
    getLeaderboards: getLeaderboards(),
  };

  function getLeaderboards() {
    return createAsyncThunk(
      `${name}/get`,
      async ({
        url,
        period,
        isCurrent,
        orgId,
      }: {
        url: string;
        period: dayjs.ManipulateType;
        isCurrent: boolean;
        orgId: string;
      }) => {
        const referenceDay = isCurrent
          ? dayjs()
          : dayjs().subtract(1, period ?? "day");
        let startDate = "";
        let endDate = "";

        const mondayOfWeek =
          dayjs().format("dd") === "Su"
            ? referenceDay.day(-6)
            : referenceDay.day(1);
        const sundayOfWeek =
          dayjs().format("dd") === "Su"
            ? referenceDay.day(0)
            : referenceDay.day(7);
        switch (period) {
          case "day":
            startDate = referenceDay.format("YYYY-MM-DD").toString();
            endDate = referenceDay.format("YYYY-MM-DD").toString();
            break;
          case "week":
            startDate = mondayOfWeek.format("YYYY-MM-DD").toString();
            endDate = sundayOfWeek.format("YYYY-MM-DD").toString();
            break;
          case "month":
            startDate = referenceDay.startOf(period).format("YYYY-MM-DD");
            endDate = referenceDay.endOf(period).format("YYYY-MM-DD");
            break;
          default:
            break;
        }

        // const state = getState() as RootState;
        // f87afa00-0bdf-4161-b8df-19e0c60e84ad  orgid
        return await axios.get(
          `${envConfig.BASE_URL}/public/${orgId}/leaderboards/${url}`,
          {
            // headers: {
            //   Authorization: `Bearer ${state.auth.authToken}`,
            // },
            params: {
              // app_name: "yodha",
              // apiToken: state.auth.authToken,
              start_date: startDate,
              end_date: endDate,
            },
          }
        );
      }
    );
  }
}

function createExtraReducers() {
  return {
    ...leaderboardsResponse(),
  };

  function leaderboardsResponse() {
    const { pending, fulfilled, rejected }: any = extraActions.getLeaderboards;
    return {
      [pending]: (state: leaderboardsState) => {
        state.error = false;
        state.loading = true;
      },
      [fulfilled]: (
        state: leaderboardsState,
        action: PayloadAction<
          { data: { data: Array<object>; meta: { slug: string } } },
          string
        >
      ) => {
        console.log(action.payload, "leaderboa");
        state.leaderboards = action.payload.data.data;
        state.userMetaInfo = action.payload.data.meta;
        state.slug = action.payload.data.meta.slug ?? "yodha";
        state.loading = false;
      },
      [rejected]: (state: leaderboardsState) => {
        state.error = true;
        state.loading = false;
      },
    };
  }
}

export const userInfoSelector = (state: any) => state.leaderboards.userMetaInfo;
export const leaderboardLoading = (state: {
  leaderboards: leaderboardsState;
}) => state.leaderboards.loading;
